import * as React from "react";
import { PostCodeAnywhereSearchEditor } from "../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { TextBoxEditor } from "../../../react-core/Html/TextBoxEditor";
import { UkPostCode } from "../../../react-core/Html/Validation/RegExPatterns";
import { CountryCode } from "../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Address as AddressModel } from "../../../Wrap/Models/Domains/Address/Address";
import { IProcessComponentProps, ProcessComponent } from "../Process/Process/ProcessComponent";
import { SelectEditor } from "../../../react-core/Html/SelectEditor";
import { CountryCodeMap } from "../Entities/Maps/CountryCodeMap";

export interface IEmployerAddressProps extends IProcessComponentProps {
    data: AddressModel;
    required: boolean;
}

export interface IEmployerAddressState {
    country: CountryCode;
}

export class EmployerAddress extends ProcessComponent<IEmployerAddressProps, IEmployerAddressState> {
    constructor(props: any) {
        super(props);
    }

    private onAddressChange(changes) {
        let { data } = this.props;
        let _data = JSON.parse(JSON.stringify(data || {}));
        if (!_data) {
            data = this.emptyAddress();
        }
        for (const key in changes) {
            _data[key] = changes[key];
        }
        this.props.onChange(_data);
    }

    private onCountryChange(country) {
        this.onAddressChange({ CountryCode: country });
        this.setState({ country: country });
    }

    render() {
        const { data, required } = this.props;

        return (
            <>
                <SelectEditor
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    onChange={(v) => this.onCountryChange(v)}
                    selected={data?.CountryCode}
                    required={"Please select country of Employer"}
                    label="Country"
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                />
                <PostCodeAnywhereSearchEditor
                    onLookupError={() => {}}
                    onAddressSelected={(v) => {
                        this.props.onChange({
                            CountryCode: data?.CountryCode, 
                            Line1: v.Line1,
                            Line2: v.Line2,
                            Line3: v.Line3,
                            Postcode: v.Postcode,
                        });
                    }}
                    countryCode={CountryCode.GBR}
                    label={`Address `}
                    useLabelForAddress
                />
                <TextBoxEditor
                    label={`Address line 1`}
                    value={data?.Line1}
                    required={required ? "Please enter Address Line1" : null}
                    onChange={(v) => this.onAddressChange({ Line1: v })}
                />
                <TextBoxEditor
                    label={`Address line 2`}
                    value={data?.Line2}
                    required={required ? "Please enter Address Line2" : null}
                    onChange={(v) => this.onAddressChange({ Line2: v })}
                />
                <TextBoxEditor
                    label="Address line 3"
                    value={data?.Line3}
                    maxLength={35}
                    onChange={(v) => this.onAddressChange({ Line3: v })}
                />
                <TextBoxEditor
                    label="Postcode"
                    value={data?.Postcode}
                    required={required ? "Please enter postcode" : null}
                    regex={{ errorMessage: this.state?.country == CountryCode.GBR ? "Please enter valid postcode" : null,
                             value: this.state?.country == CountryCode.GBR ? UkPostCode : null }}
                    onChange={(v) => this.onAddressChange({ Postcode: v })}
                />
            </>
        );
    }
    private emptyAddress(): AddressModel {
        return { Line1: null, Line2: null, Line3: null, Line4: null, Postcode: null, CountryCode:null };
    }
}
